'use client'

import { Tabs, TabsList, TabsTrigger } from '@repo/ui/components'

import { usePathname, useRouter, useSearchParams } from '../adapters/next'

interface IOptions {
  label: string
  value: string
}

interface IProps {
  options: IOptions[]
  source?: number | string
}

export const FilterTabs = ({ options, source = '' }: IProps) => {
  const router = useRouter()
  const searchParams = useSearchParams()
  const pathname = usePathname()

  function handleTabChange(source: string) {
    const params = new URLSearchParams(searchParams)
    params.delete('page')
    if (source) {
      params.set('source', source)
    } else {
      params.delete('source')
    }
    router.push(`${pathname}?${params.toString()}`)
  }

  return (
    <Tabs value={source?.toString() ?? ''} data-sentry-element="Tabs" data-sentry-component="FilterTabs" data-sentry-source-file="filter-tabs.tsx">
      <TabsList data-sentry-element="TabsList" data-sentry-source-file="filter-tabs.tsx">
        {options.map(dataSource => (
          <TabsTrigger
            key={dataSource.value}
            onClick={() => {
              handleTabChange(dataSource.value)
            }}
            value={dataSource.value}
          >
            {dataSource.label}
          </TabsTrigger>
        ))}
      </TabsList>
    </Tabs>
  )
}
